import { hasActiveMobileForegroundTask } from './mobileRuntimeState'

let activeRegistration = null
let reloadForUpdate = false

function announceUpdate(registration) {
  activeRegistration = registration
  window.dispatchEvent(new CustomEvent('mobile-sw-update-ready'))
}

export async function registerMobileServiceWorker() {
  if (
    process.env.NODE_ENV !== 'production'
    || typeof window === 'undefined'
    || !window.location.pathname.startsWith('/mobile/')
    || !('serviceWorker' in navigator)
  ) return null

  const registration = await navigator.serviceWorker.register('/mobile/mobile-service-worker.js', {
    scope: '/mobile/',
    updateViaCache: 'none'
  })
  activeRegistration = registration

  if (registration.waiting && navigator.serviceWorker.controller) announceUpdate(registration)
  registration.addEventListener('updatefound', () => {
    const worker = registration.installing
    if (!worker) return
    worker.addEventListener('statechange', () => {
      if (worker.state === 'installed' && navigator.serviceWorker.controller) announceUpdate(registration)
    })
  })

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (reloadForUpdate) window.location.reload()
  })
  void registration.update()
  return registration
}

export function activateMobileServiceWorkerUpdate() {
  if (hasActiveMobileForegroundTask()) return false
  const waiting = activeRegistration?.waiting
  if (!waiting) return false
  reloadForUpdate = true
  waiting.postMessage({ type: 'SKIP_WAITING' })
  return true
}

export async function clearMobileUserCaches() {
  if (typeof navigator !== 'undefined' && 'serviceWorker' in navigator) {
    const registration = await navigator.serviceWorker.getRegistration('/mobile/')
    registration?.active?.postMessage({ type: 'CLEAR_MOBILE_USER_CACHES' })
  }
}
